module.exports = __webpack_public_path__ + "media/images/ohap_assignment_on-9128f493a9ad4146da43a28c244cea21.png";